import uuid from 'uuid/v4';
import _ from 'lodash';
import * as types from '../actions/actionTypes';
import initialState from './initialState';
import * as CrosstabUtils from '../util/CrosstabUtils';
import * as MMEUtils from '../util/MMEUtils';
import { ALL_ADULTS } from '../components/mme/MMEConstants';

export default (state = initialState.mmeModule, action) => {
  switch (action.type) {
    case types.FETCH_MME_STANDARD_BASE_LIST: {
      if (action.payload.length > 0) {
        return {
          ...state,
          runReportFlag: false,
          standardBaseLists: action.payload,
        };
      }
      return {
        ...state,
        runReportFlag: false,
        standardBaseLists: action.payload,
        StandardBasesDataGridData: action.payload,
      };
    }
    case types.GET_MME_SAMPLE_WEIGHTED: {
      // Required Parameters: payload, targetGrid, expressionList, selectedNames
      // Optional Parameters: sourceGrid, gridData, titlePrefix, originalNames
      const keyType = `${action.targetGrid}Data`;
      let gridData = [];
      const oldProductNo = action.oldProductNo && action.oldProductNo;
      if (action.gridData || (oldProductNo && oldProductNo !== action.productNo)) {
        gridData = action.gridData ? action.gridData : [];
      } else if (state[keyType]) {
        gridData = state[keyType];
      }
      const titlePrefix = action.titlePrefix ? action.titlePrefix : '';
      const selectedKPIsTitle = { ...state.selectedKPIsTitle };

      const savedKPIs = { ...state.allSelectedKPIsInfo };
      const sampleWeightedKPIs = { ...state.sampleWeightedKPIs };
      action.expressionList.forEach((item, index) => {
        savedKPIs[item] = {
          modeled: action.payload[index] ? action.payload[index].modeled : false,
          productNo: action.productNo,
        };
        sampleWeightedKPIs[item] = {
          productNo: action.productNo,
          data: action.payload[index] ? [action.payload[index]] : [],
        };
      });
      const keywordArr = gridData.map(elems => {
        return elems.keyword.trim();
      });
      const titleArr = gridData.map(elems => {
        return elems.title.trim().toUpperCase();
      });
      const draggedItems = [];
      action.payload.forEach((selectedEntry, index) => {
        let title = '';
        title = `${titlePrefix.toUpperCase()}${action.selectedNames[index].toUpperCase()}`;
        let originalTitle = title;
        const rectype = action.recTypes && action.recTypes[index];
        selectedKPIsTitle[action.expressionList[index]] = title;
        if (action.originalNames && action.originalNames.length > 0) {
          originalTitle = action.originalNames[index];
        }
        // else if (
        //   action.sourceGrid !== 'ColumnsDataGrid' &&
        //   action.sourceGrid !== 'RowsDataGrid' &&
        //   action.sourceGrid !== 'BasesDataGrid' &&
        //   action.sourceGrid !== 'ScratchDataGrid' &&
        //   action.sourceGrid !== 'ExpressionCodingBox' &&
        //   action.sourceGrid !== 'StandardBasesDataGrid' &&
        //   action.sourceGrid !== 'FunctionBox'
        // ) {
        //   originalTitle = CrosstabUtils.DEFAULT_GRID_CELL_LABEL;
        // }
        const weighted =
          selectedEntry && selectedEntry.weighted
            ? Number(selectedEntry.weighted)
            : '';
        const updatedWeighted = CrosstabUtils.smartRoundOff(weighted);

        if (keywordArr.indexOf(action.expressionList[index].trim()) === -1 ||
          titleArr.indexOf(title.trim()) === -1) {
          draggedItems.push({
            id: uuid(),
            sample: selectedEntry && selectedEntry.intab ? selectedEntry.intab : '',
            keyword: action.expressionList[index],
            weighted: updatedWeighted === 0 ? '' : updatedWeighted,
            title,
            originalTitle,
            rectype,
            dataSmartSearch: action.objSmartSearchArray ?
              action.objSmartSearchArray[index] : undefined,
          });
        }
      });
      let finalData = [];
      finalData = [...gridData, ...draggedItems];
      return {
        ...state,
        runReportFlag: false,
        selectedKPIsTitle,
        [keyType]: finalData,
        allSelectedKPIsInfo: savedKPIs,
        sampleWeightedKPIs,
      };
    }
    case types.GET_MME_SAMPLE_WEIGHTED_DATA: {
      // Required Parameters: payload, targetGrid, expressionList, selectedNames
      // Optional Parameters: sourceGrid, gridData, titlePrefix, originalNames
      const keyType = `${action.targetGrid}Data`;
      const gridData = action.gridData ? action.gridData : [];
      const sampleWeightedKPIs = { ...state.sampleWeightedKPIs };
      const savedKPIs = { ...state.allSelectedKPIsInfo };
      const selectedKPIsTitle = { ...state.selectedKPIsTitle };
      const titlePrefix = action.titlePrefix ? action.titlePrefix : '';

      action.expressionList.forEach((item, index) => {
        savedKPIs[item] = {
          modeled: action.payload[index] ? action.payload[index].modeled : false,
          productNo: action.productNo,
        };
        sampleWeightedKPIs[item] = {
          productNo: action.productNo,
          data: action.payload[index] ? [action.payload[index]] : [],
        };
      });
      const keywordArr = gridData.map(elems => {
        return elems.keyword;
      });
      const titleArr = gridData.map(elems => {
        return elems.title.trim().toUpperCase();
      });
      const draggedItems = [];

      action.payload.forEach((selectedEntry, index) => {
        const title = `${titlePrefix.toUpperCase()}${action.selectedNames[index].toUpperCase()}`;
        let originalTitle = title;
        selectedKPIsTitle[action.expressionList[index]] = title;
        const rectype = action.recTypes && action.recTypes[index];
        if (action.originalNames && action.originalNames.length > 0) {
          originalTitle = action.originalNames[index];
        } else if (
          action.sourceGrid !== 'TargetsDataGrid' &&
          action.sourceGrid !== 'BasesDataGrid'
        ) {
          originalTitle = CrosstabUtils.DEFAULT_GRID_CELL_LABEL;
        }
        const weighted = selectedEntry && selectedEntry.weighted ? Number(selectedEntry.weighted) : '';
        if (keywordArr.indexOf(action.expressionList[index]) === -1 ||
          titleArr.indexOf(title.trim()) === -1) {
          draggedItems.push({
            id: uuid(),
            sample: selectedEntry && selectedEntry.intab ? selectedEntry.intab : '',
            keyword: action.expressionList[index],
            weighted,
            title,
            originalTitle,
            rectype,
            dataSmartSearch: action.objSmartSearchArray ?
              action.objSmartSearchArray[index] : undefined,
          });
        }
      });
      return {
        ...state,
        runReportFlag: false,
        selectedKPIsTitle,
        [keyType]: [...gridData, ...draggedItems],
        allSelectedKPIsInfo: savedKPIs,
        sampleWeightedKPIs,
      };
    }
    case types.CLEAR_MME_SAMPLE_WEIGHTED: {
      const keyType = `${action.targetGrid}Data`;
      const recycleElements = state.RecycleGridData
        ? [...state.RecycleGridData]
        : [];
      const selectedGridData = state[keyType] ? [...state[keyType]] : [];
      return {
        ...state,
        runReportFlag: false,
        [keyType]: [],
        RecycleGridData: [...selectedGridData, ...recycleElements],
      };
    }
    case types.UPDATE_MME_SAMPLE_WEIGHTED: {
      const keyType = `${action.targetGrid}Data`;
      const keywordArr = [];
      const gridData = [];
      const titleArr = [];
      action.gridData.forEach(elems => {
        if (keywordArr.indexOf(elems.keyword.trim()) === -1 ||
          titleArr.indexOf(elems.title.trim()) === -1) {
          keywordArr.push(elems.keyword.trim());
          titleArr.push(elems.title.trim());
          gridData.push(elems);
        }
      });
      return {
        ...state,
        runReportFlag: false,
        [keyType]: [...gridData],
      };
    }
    case types.UPDATE_MME_TITLE_HEADER: {
      const mmeTitleHeaderList = { ...state.mmeTitleHeaderList };

      const updatedHeader = mmeTitleHeaderList[action.payload.gridCategory] ?
        _.cloneDeep(mmeTitleHeaderList[action.payload.gridCategory]) : [];
      if (updatedHeader.length > 0) {
        const matchedItem = updatedHeader.filter(item => item.keyword === action.payload.keyword);
        if (matchedItem.length > 0) {
          const indexToDelete = updatedHeader.findIndex(item =>
              item.keyword === matchedItem[0].keyword);
          if (indexToDelete !== -1) {
            if (action.payload.updatedTitle !== updatedHeader[indexToDelete].originalTitle) {
              updatedHeader.splice(indexToDelete, 1);
              updatedHeader.push({
                index: action.payload.index,
                originalTitle: action.payload.originalTitle,
                updatedTitle: action.payload.updatedTitle,
                keyword: action.payload.keyword,
              });
            } else {
              updatedHeader.splice(indexToDelete, 1);
            }
          }
        } else {
          updatedHeader.push({
            index: action.payload.index,
            originalTitle: action.payload.originalTitle,
            updatedTitle: action.payload.updatedTitle,
            keyword: action.payload.keyword,
          });
        }
      } else {
        updatedHeader.push({
          index: action.payload.index,
          originalTitle: action.payload.originalTitle,
          updatedTitle: action.payload.updatedTitle,
          keyword: action.payload.keyword,
        });
      }
      mmeTitleHeaderList[action.payload.gridCategory] = updatedHeader;

      return {
        ...state,
        runReportFlag: false,
        mmeTitleHeaderList,
      };
    }
    case types.UPDATE_MME_GRID: {
      const mmeTableList = state.mmeTableList
        ? state.mmeTableList
        : [];
      return {
        ...state,
        runReportFlag: false,
        mmeTableList: mmeTableList.map(mmeTable => {
          if (mmeTable.idKey === action.idKey) {
            return {
              ...mmeTable,
              ...action.updatedData,
            };
          }

          return { ...mmeTable };
        }),
      };
    }
    case types.SET_SELECTED_MME_BASE: {
      return {
        ...state,
        runReportFlag: false,
        selectedBase: {
          selectedBase: action.selectedBase,
          selectedBaseNode: action.selectedBaseNode,
          selectedBaseGroup: action.selectedBaseGroup,
        },
      };
    }
    case types.FETCH_MME_MEDIA_LIST: {
      const websitePropertiesList = action.payload.ml.filter(item => {
        return item.c.startsWith('I');
      }).sort((a, b) => (a.n > b.n) ? 1 : -1);
      const magazinePropertiesList = action.payload.ml.filter(item => {
        return item.c.startsWith('M');
      }).sort((a, b) => (a.n > b.n) ? 1 : -1);
      const programPropertiesList = action.payload.ml.filter(item => {
        return item.c.startsWith('T') && !item.nw;
      }).sort((a, b) => (a.n > b.n) ? 1 : -1);
      const networkPropertiesList = action.payload.ml.filter(item => {
        return item.c.startsWith('T') && item.nw === true;
      }).sort((a, b) => (a.n > b.n) ? 1 : -1);
      const streamingPropertiesList = action.payload.ml.filter(item => {
        return item.c.startsWith('S');
      }).sort((a, b) => (a.n > b.n) ? 1 : -1);

      const websiteSl = action.payload.sl.filter(item => item.c === 'I');
      const magazineSl = action.payload.sl.filter(item => item.c === 'M');
      const tvSl = action.payload.sl.filter(item => item.c === 'T');
      const generalSl = action.payload.sl.filter(item => item.c !== 'I' && item.c !== 'M' && item.c !== 'T' &&
        item.c !== 'S');
      const streamS1 = action.payload.sl.filter(item => item.c === 'S');
      const generalDl = action.payload.dl.filter(item => item.c === 'Z');
      const tvDl = action.payload.dl.filter(item => item.c === 'T');
      const websiteDl = action.payload.dl.filter(item => item.c === 'I');
      const magazineDl = action.payload.dl.filter(item => item.c === 'M');
      const streamDl = action.payload.dl.filter(item => item.c === 'S');
      return {
        ...state,
        runReportFlag: false,
        mediaList: {
          0: networkPropertiesList,
          1: programPropertiesList,
          2: websitePropertiesList,
          3: magazinePropertiesList,
          4: streamingPropertiesList,
        },
        statementList: {
          0: generalSl,
          1: tvSl,
          2: websiteSl,
          3: magazineSl,
          4: streamS1,
        },
        dimensionList: {
          0: generalDl,
          1: tvDl,
          2: websiteDl,
          3: magazineDl,
          4: streamDl,
        },
      };
    }
    case types.UPDATE_SELECTED_MEDIA_VEHICLE: {
      return {
        ...state,
        runReportFlag: false,
        selectedMediaVehicleIndex: action.mediaVehicleIndex,
      };
    }
    case types.ON_CHANGE_PROPERTY: {
      const tempList = _.cloneDeep(action.originalList);
      const DimensionTypeArr = [0, 1, 2, 3, 4];
      DimensionTypeArr.splice(action.selectedIndex, 1);
      _.forEach(DimensionTypeArr, item => {
        _.forEach(tempList[Object.keys(tempList)[item]], arr => {
          _.set(arr, 's', 0);
        });
      });
      if (action.listToBeUpdate !== 'mediaList') {
        return {
          ...state,
          runReportFlag: false,
          [action.listToBeUpdate]: {
            0: [...tempList[0]],
            1: [...tempList[1]],
            2: [...tempList[2]],
            3: [...tempList[3]],
            4: [...tempList[4]],
            [action.selectedIndex]: action.updatedList,
          },
        };
      } 
        return {
          ...state,
          runReportFlag: false,
          [action.listToBeUpdate]: {
            ...action.originalList,
            [action.selectedIndex]: action.updatedList,
          },
        };
      
    }
    case types.UPDATE_SELECTED_STATEMENT_VARIABLES: {
      return {
        ...state,
        runReportFlag: false,
        statementVariableSelected: [...action.selected],
      };
    }
    case types.SHOW_MME_GRID: {
      const {
        payload,
        reportType,
      } = action;

      const {
        statementVariableLabel,
        scoreListColorValue,
        mmeTargetList,
        activeTarget,
        vehicleCodes,
        statementVariables,
        scoreList,
        base,
      } = action.dispatchData;

      const MMEDataParams = {
        mmeData: payload,
        scoreListColorValue,
      };
      const newMMETable = MMEUtils.populateMMEData(
        MMEDataParams,
        reportType,
      );
      const mmeTableList = [newMMETable];
      const nextStateReportType = state.prevMMEReportType;
      const nextStateVehicleCodes = _.cloneDeep(state.prevMMEVehicleCodes);
      const nextStateStatements = _.cloneDeep(state.prevMMEStatements);
      const nextStateStatementVariables = _.cloneDeep(state.prevMMEStatementVariables);
      let nextStateMMEAllTargetsTableList = { ...state.mmeAllTargetsTableList };
      const mmeTargetKeywords = mmeTargetList.map(item => item.keyword);
      if (
        !_.isEqual(_.sortBy(vehicleCodes), _.sortBy(nextStateVehicleCodes)) ||
        !_.isEqual(_.sortBy(scoreList), _.sortBy(nextStateStatements)) ||
        !_.isEqual(_.sortBy(statementVariables), _.sortBy(nextStateStatementVariables)) ||
        nextStateReportType !== reportType
      ) {
        nextStateMMEAllTargetsTableList = {};
      } else {
        Object.keys(nextStateMMEAllTargetsTableList).forEach(key => {
          if (!mmeTargetKeywords.includes(key)) {
            delete nextStateMMEAllTargetsTableList[key];
          }
        });
      }
      if (!(activeTarget in nextStateMMEAllTargetsTableList) && base === 'StudyUniverseKey') {
        nextStateMMEAllTargetsTableList[activeTarget] = mmeTableList;
      }
      return {
        ...state,
        runReportFlag: true,
        mmeTableList,
        isEnableMMEViewer: true,
        statementVariableLabel,
        mmeAllTargets: mmeTargetList,
        mmeAllTargetsTableList: nextStateMMEAllTargetsTableList,
        landingTarget: activeTarget,
        prevMMEVehicleCodes: vehicleCodes,
        prevMMEStatementVariables: statementVariables,
        prevMMEStatements: scoreList,
        prevMMEReportType: reportType,
        prevMMEBase: base,
      };
    }

    case types.UPDATE_REPORT_TYPE_VARIABLE: {
      return {
        ...state,
        runReportFlag: false,
        reportType: action.selected,
      };
    }

    case types.UPDATE_DIMENSION_TYPE_VARIABLE: {
      return {
        ...state,
        runReportFlag: false,
        dimensionType: Number(action.selected),
      };
    }

    case types.ENABLE_MME_EDITOR_VIEW: {
      const TargetsDataGridData = _.cloneDeep(state.TargetsDataGridData);
      const landingTarget = _.cloneDeep(state.landingTarget);
      const activeTarget = !TargetsDataGridData.map(item => item.keyword).includes(landingTarget) ?
        ALL_ADULTS : landingTarget;
      return {
        ...state,
        runReportFlag: false,
        isEnableMMEViewer: false,
        landingTarget: activeTarget,
      };
    }

    case types.UPDATE_MME_TAB_GRID_DATA: {
      const { activeTarget } = action;
      return {
        ...state,
        runReportFlag: true,
        mmeTableList: [...state.mmeAllTargetsTableList[action.activeTarget]],
        landingTarget: activeTarget,
      };
    }

    case types.EXPORT_MME: {
      const link = document.createElement('a');
      document.body.appendChild(link);
      if (action.payload.url) {
        link.href = action.payload.url;
      } else {
        link.href = '#';
      }
      link.click();
      return state;
    }

    case types.SHOW_MME_VALIDATED_DATA: {
      const TargetsDataGridData = _.cloneDeep(state.TargetsDataGridData);
      const landingTarget = _.cloneDeep(state.landingTarget);
      const activeTarget = !TargetsDataGridData.map(item => item.keyword).includes(landingTarget) ?
        ALL_ADULTS : landingTarget;
      return {
        ...state,
        runReportFlag: false,
        mmeAllTargetsTableList: {},
        gridsValidationResponse: {
          ...action.payload,
          oldStudy: action.oldStudy,
        },
        landingTarget: activeTarget,
      };
    }

    case types.UPDATE_PREVIOUS_LIST_SELECTION: {
      const mediaList = _.cloneDeep(state.mediaList);
      const prevVehicleCodes = [...state.prevMMEVehicleCodes];
      const tempMediaList = {};
      const statementDimensionList = state.reportType === 'SR' ?
        _.cloneDeep(state.statementList) : _.cloneDeep(state.dimensionList);
      const tempSDList = {};
      const prevStatementList = state.prevMMEStatements;
      const tempArr = [0, 1, 2, 3, 4];
      tempArr.forEach(index => {
        tempMediaList[index] = mediaList[index].map(item => {
          if (prevVehicleCodes.includes(item.c)) {
            item.s = 1;
          }
          return item;
        });
      });
      tempArr.forEach(index => {
        tempSDList[index] = statementDimensionList[index].map(item => {
          if (prevStatementList.includes(item.v)) {
            item.s = 1;
          }
          return item;
        });
      });
      if (state.reportType === 'SR') {
        return {
          ...state,
          runReportFlag: false,
          mediaList: { ...tempMediaList },
          statementList: { ...tempSDList },
          prevMMEVehicleCodes: [],
          prevMMEStatements: [],
        };
      }
      return {
        ...state,
        runReportFlag: false,
        mediaList: { ...tempMediaList },
        dimensionList: { ...tempSDList },
        prevMMEVehicleCodes: [],
        prevMMEStatements: [],
      };
    }

    case types.UPDATE_PREVIOUS_SELECTED_DATA: {
      return {
        ...state,
        runReportFlag: false,
        prevMMEVehicleCodes: action.media,
        prevMMEStatements: action.statement,
      };
    }

    case types.RESET_MME_EDITOR_VIEW_TO_DEFAULT: {
      return {
        ...state,
        runReportFlag: false,
        selectedMediaVehicleIndex: 0,
        dimensionType: 0,
        statementVariableSelected: [...'0', '1'],
      };
    }

    case types.CLEAR_MME_GRID_DATA: {
      const dataType = `${action.target}Data`;
      return {
        ...state,
        [dataType]: [],
      };
    }

    case types.CLEAR_MME_TARGETS: {
      const selectedTableList = state.mmeAllTargetsTableList[action.target];
      const updatedObj = { [action.object]: selectedTableList };
      return {
        ...state,
        mmeAllTargetsTableList: updatedObj,
      };
    }

    default:
      return state;
  }
}
